import Qs from 'qs'
import { getToken, setToken, getAuthMeta, setAuthMeta } from './auth'
import { kitBindContext } from './kitBindContext'

function parseQuery (text) {
  const result = {}
  String(text || '').replace(/^\?/, '').split('&').forEach(pair => {
    if (!pair) return
    const parts = pair.split('=')
    const key = decodeURIComponent(parts.shift() || '')
    if (key) result[key] = decodeURIComponent(parts.join('=') || '')
  })
  return result
}

export function readEntryQuery (route) {
  const hash = window.location.hash || ''
  const hashQuery = hash.indexOf('?') > -1 ? parseQuery(hash.substring(hash.indexOf('?') + 1)) : {}
  const searchQuery = parseQuery(window.location.search)
  return Object.assign({}, searchQuery, hashQuery, (route && route.query) || {})
}

export async function ensureH5Session (vm) {
  const query = readEntryQuery(vm.$route)
  const authMeta = getAuthMeta()
  const incomingTicket = String(query.ticket || '').trim()

  // ticket 的优先级最高。即使已有账号密码登录态，只要入口携带 ticket，
  // 也必须按当前 ticket 重新鉴权，模拟环境同样由后端 ticketLogin 处理。
  if (incomingTicket && (!getToken() || authMeta.ticket !== incomingTicket || authMeta.authMode === 'password')) {
    const res = await vm.$http.post('/h5/auth/ticketLogin', Qs.stringify({
      ticket: incomingTicket,
      channel: query.channel || '',
      envKey: query.envKey || '',
      fromWechat: /micromessenger/i.test(window.navigator.userAgent || '') ? '1' : '0'
    }), {
      timeout: 15000
    })
    const accessToken = res.data && (res.data.accessToken || res.data.access_token)
    if (res.result !== '1' || !res.data || !accessToken) {
      throw new Error(res.desc || '登录失败')
    }
    setToken(accessToken)
    setAuthMeta({
      ticket: incomingTicket,
      channel: query.channel || '',
      envKey: res.data.envKey || query.envKey || '',
      authMode: res.data.authMode || '',
      externalUserId: res.data.externalUserId || '',
      source: res.data.source || '',
      userId: res.data.userId || '',
      userName: res.data.userName || '',
      trueName: res.data.trueName || '',
      phone: res.data.phone || '',
      idCard: res.data.idCard || ''
    })
  }

  if (!getToken()) {
    throw new Error('请先登录')
  }
  kitBindContext(query, query.pid)
  return Object.assign({}, getAuthMeta(), query)
}

export function retainedQuery (extra) {
  const auth = getAuthMeta()
  return Object.assign({
    ticket: auth.ticket || '',
    channel: auth.channel || '',
    envKey: auth.envKey || ''
  }, extra || {})
}



// WEBPACK FOOTER //
// ./src/utils/session.js